import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { useForm } from "react-hook-form";
import s from "./styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../CustomInput";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { fetchAgents } from "../../../../entities/Agents/model/agents";
import useAuth from "../../../../hooks/useAuth";

function DeletePropertyModal({ open, onClose, setOpenModal, id }) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const { auth } = useAuth();
  const token = auth?.access_token;
  const agents = useSelector((state) => state.agents.agents);
  const agent_id = auth?.agent_id;
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const handleClose = () => {
    reset({});
    onClose();
  };

  useEffect(() => {
    dispatch(fetchAgents(token));
  }, [dispatch, token]);

  useEffect(() => {
    reset({
      AgentID: undefined,
      TotalCommission: undefined,
      Comment: undefined,
    });
  }, [reason, reset]);

  const onSubmit = async () => {
    setLoading(true);

    const agentId =
      reason === "Сделка BM Group"
        ? Number(watch("AgentID"))
        : Number(agent_id);
    const data = {
      PropertyID: Number(id),
      Reason: reason,
      AgentID: agentId,
      ...(reason === "Сделка BM Group" && {
        TotalCommission: parseFloat(watch("TotalCommission")),
      }),
      ...(reason === "Другая причина" && { Comment: watch("Comment") }),
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/property/deal/`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );

      if (response.ok) {
        setLoading(false);
        reset();
        toast.success("Успешно отправлено");
        onClose();
        navigate("/myProperties");
      } else {
        const responseDataError = await response.json();
        toast.error("Ошибка при отправке");
        setLoading(false);
        console.error("Ошибка при отправке");
      }
    } catch (error) {
      setLoading(false);
      console.error("Ошибка сети", error);
      toast.error("Ошибка сети", error);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 700,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <p style={{ fontSize: 22, fontWeight: 500, marginBottom: 50 }}>
          Укажите причину удаления объявления
        </p>
        <RadioGroup value={reason} onChange={(e) => setReason(e.target.value)}>
          <FormControlLabel
            value="Сделка BM Group"
            control={<Radio />}
            label="Сделка BM Group"
          />
          <FormControlLabel
            value="Дубликат"
            control={<Radio />}
            label="Дубликат"
          />
          <FormControlLabel
            value="Продали сами"
            control={<Radio />}
            label="Продали сами"
          />
          <FormControlLabel
            value="Ушли к конкурентам"
            control={<Radio />}
            label="Ушли к конкурентам"
          />
          <FormControlLabel
            value="Решили отложить продажу"
            control={<Radio />}
            label="Решили отложить продажу"
          />
          <FormControlLabel
            value="Другая причина"
            control={<Radio />}
            label="Другая причина"
          />
        </RadioGroup>

        {reason === "Сделка BM Group" && (
          <div className={s.row}>
            <div className={s.select}>
              <p htmlFor="AgentID">Выбрать агента</p>
              <select
                id="AgentID"
                value={watch("AgentID") || ""}
                onChange={(e) =>
                  setValue("AgentID", e.target.value, { shouldValidate: true })
                }
              >
                <option value="">Выберите агента</option>
                {agents.map((agent) => (
                  <option key={agent.id} value={agent.id}>
                    {agent.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <CustomInput
                name="TotalCommission"
                label="Общая комиссия"
                placeholder="Укажите общую комиссию"
                type="number"
                error={!!errors.TotalCommission}
                helperText={errors.TotalCommission?.message || ""}
                inputRef={
                  register("TotalCommission", {
                    required: "Заполните поле",
                  }).ref
                }
                {...register("TotalCommission", {
                  required: "Заполните поле",
                })}
              />
            </div>
          </div>
        )}

        {reason === "Другая причина" && (
          <div>
            <CustomInput
              name="Comment"
              label="Комментарий"
              placeholder="Поясните"
              type="text"
              error={!!errors.Comment}
              helperText={errors.Comment?.message || ""}
              inputRef={
                register("Comment", {
                  required: "Заполните поле",
                }).ref
              }
              {...register("Comment", {
                required: "Заполните поле",
              })}
            />
          </div>
        )}

        <div className={s.buttons}>
          <button className={s.cancel} onClick={handleClose}>
            Отмена
          </button>
          {loading ? (
            <div className="loader"></div>
          ) : (
            <button className={s.delete} onClick={handleSubmit(onSubmit)}>
              Удалить объявление
            </button>
          )}
        </div>
      </Box>
    </Modal>
  );
}

export default DeletePropertyModal;
